/**
 * FAQ Page
 * Frequently asked questions
 */

import { FaqSection } from '@/components/sections/faq';
import { CtaSection } from '@/components/sections/cta';

export function FaqPage() {
  return (
    <>
      <div className="pt-24">
        <div className="max-w-7xl mx-auto px-4 py-16 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Frequently Asked Questions</h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Got questions? We've got answers. Can't find what you're looking for? Reach out to our team.
          </p>
        </div>
      </div>
      <FaqSection />
      <CtaSection />
    </>
  );
}
